// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__-ubgI","shine":"Skeleton_shine__bNoWJ","skeletonLight":"Skeleton_skeletonLight__3Kjyz","skeletonDark":"Skeleton_skeletonDark__h0OqM"};